import { Injectable } from '@angular/core';
export {};
 
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}
@Injectable({
  providedIn: 'root'
})
export class ReactMobileService {
 
  private sendMessage(data: any) {
    try {
      if (window.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      } else {
        console.log('RN WebView not available');
      }
    } catch (e) {
      console.error('RN Bridge Error:', e);
    }
  } 

  public responseFromWeb(
    message: string, 
    isErrorResponse: boolean,
    isLogoutUser: boolean,  
    isConsoleLogRequest: boolean,
  ) { 
    this.sendMessage({ 
      type: 'Response_From_Web', 
      isErrorResponse: isErrorResponse,
      isLogoutUser: isLogoutUser,  
      isConsoleLogRequest: isConsoleLogRequest,
      message: message
    });
  }
}